import { spawn } from "redux-saga/effects";
import { pageSaga } from "../components/Page/redux/PageSaga";
import { featureManagementSaga } from "../FeatureManagement/redux/FeatureManagementSaga";
import { testSaga } from "../../views/TestView/redux/TestSaga";

export default function* rootSaga() {
    yield spawn(pageSaga);
    yield spawn(testSaga);
    yield spawn(featureManagementSaga);
}
